const MoviesCarousel = [
    {
        name: 'Outer Banks',
        subtitle: '4° Temporada',
        overview: 'Em uma ilha com moradores pobres e ricos, John B e sua turma vivem aventuras cheias de mistério em busca de um tesouro perdido.',
        vote_average: 8.4,
        year: 2020,
        media_type: 'tv',
        id_tmdb: 100757,
        id_imdb: 'tt10293938',
        can_watch_on: [ 'web', 'app', 'tv' ],
        age_rating: 16,
        background_path: 'tMLH2VDnTpZLYg7T4QPBjaaleVx.jpg'
    },
    
];

export default MoviesCarousel